export default __webpack_public_path__ + "static/media/Chukor.6d58e421.jpg";